import { render, staticRenderFns } from "./PanelVideoTeam.vue?vue&type=template&id=3b90c1f0&"
import script from "./PanelVideoTeam.vue?vue&type=script&lang=js&"
export * from "./PanelVideoTeam.vue?vue&type=script&lang=js&"
import style0 from "./PanelVideoTeam.vue?vue&type=style&index=0&id=3b90c1f0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b90c1f0')) {
      api.createRecord('3b90c1f0', component.options)
    } else {
      api.reload('3b90c1f0', component.options)
    }
    module.hot.accept("./PanelVideoTeam.vue?vue&type=template&id=3b90c1f0&", function () {
      api.rerender('3b90c1f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/panels/PanelVideoTeam.vue"
export default component.exports